module.exports = {
  "menu.dashboard": "Dashboard",
  "menu.admin": "System Administration",
  "menu.admin.user": "Staff Accounts",
  "menu.admin.client": "Integration Partners",
  "menu.admin.permission": "Permissions",
  "menu.admin.menu": "Menu Package",
  "menu.admin.promotion": "Promotion Package",
  "menu.admin.system-banner": "System Banner",
  "menu.admin.company-notification": "Company Notifications",
  "menu.admin.dynamic-report-editor": "Dynamic Report",
  "menu.exception.403": "403",
  "menu.exception.404": "404",
  "menu.exception.500": "500",
  "menu.exception": "Exception",
  "menu.exception.not-permission": "403",
  "menu.exception.not-find": "404",
  "menu.exception.server-error": "500",
  "menu.exception.trigger": "Trigger",
  "menu.company": "Bus Company",
  "menu.company.list": "Bus Company List",
  "menu.company.account": "Bus Company Accounts",
  "menu.company.zalo-oa-account": "ZaloOA Accounts",
  "menu.company.update": "Update Bus Company",
  "menu.company.brandname": "Brand SMS",
  "menu.company.invoice-config": "VDT Connection Config",
  "menu.company.merchant-payment": "Payment Gateway",
  "menu.company.vehicle-utilities": "Vehicle Utilities",
  "menu.company.company-partner": "Companies Partner",
  "menu.company.report": "Reports",
  "menu.company.report.balance-fluctuation": "System Wallet Transactions",
  "menu.company.report.balance-fluctuation-missing": "Check Fee Deduction",
  "menu.company.report.data-sync": "Check Synchronization",
  "menu.company.report.services": "Companies Services",
  "menu.company.report.services-used": "Used Company Services",
  "menu.dashboard.workplace": "Workplace",
  "menu.dashboard.tickets": "Tickets",
  "menu.dashboard.goods": "Goods",
  "menu.dashboard.analytics": "Ticket Map",
  "menu.dashboard.monitor": "Finance",
  "menu.dashboard.yearly-report": "Yearly Summary",
  "menu.dashboard.company-yearly-report": "Company Overview",
  "menu.account": "Account",
  "menu.report": "Report",
  "menu.report.company-revenue": "Bus Company Revenue",
  "menu.report.company-charge-wallet": "Bus Company Wallet Top-up",
  "menu.report.company-payment-transaction": "Company Payment Transactions",
  "menu.menu": "Package Management",
  "menu.menu.list": "Menu List by Package",
  "menu.customer": "Customer",
  "menu.customer.lead": "New Customer",
  "menu.customer.list": "Potential Customer",
  "menu.customer.care": "Customer Care",
  "menu.customer.customer-status": "Customer Status",
  "menu.vietqr": "VietQR",
  "menu.vietqr.mbqr": "MB QR",
  "menu.vietqr.mbqr.dashboard": "Overview",
  "menu.vietqr.mbqr.payments": "Payment Transactions",
  "menu.vietqr.mbqr.terminals": "Registered Bus Companies",
  "menu.vietqr.mbqr.refunds": "Refund Transactions",
  "menu.vietqr.bidvqr": "BIDV QR",
  "menu.vietqr.bidvqr.dashboard": "Overview",
  "menu.vietqr.bidvqr.payments": "Payment Transactions",
  "menu.vietqr.bidvqr.terminals": "Registered Bus Companies",
  "menu.vietqr.bidvqr.refunds": "Refund Transactions",
  "menu.vietqr.napas": "NAPAS QR",
  "menu.vietqr.napas.dashboard": "Overview",
  "menu.vietqr.napas.payments": "Payment Transactions",
  "menu.vietqr.napas.terminals": "Registered Bus Companies",
  "menu.vietqr.vpb-qr": "VPBank QR",
  "menu.vietqr.vpb-qr.dashboard": "Overview",
  "menu.vietqr.vpb-qr.payments": "Payment Transactions",
  "menu.vietqr.vpb-qr.terminals": "Registered Bus Companies",
  "menu.vietqr.vpb-qr.vpbank-customer-sdk-log": "VPBank Account Registration Customers",
  "menu.vietqr.cloud-speaker": "Payment Speaker",
  "menu.partner-devices": "Partner Devices",
  "menu.partner-devices.lhv-partner": "Loa Heo Vang",
  "menu.partner-devices.dashboard": "Dashboard",
  "menu.partner": "Ticket Sales Partner",
  "menu.partner.list": "List",
  "menu.partner.brandname": "Brand SMS",
  "menu.transit-with-partner": "Transit",
  "menu.transit-with-partner.dashboard": "Overview",
  "menu.transit-with-partner.coordination": "Transit Coordination",
  "menu.transit-with-partner.coordination-history": "Coordination History",
  "menu.transit-with-partner.transit-dispatch-display-config": "Transit Dispatch Display Settings",
  "menu.transit-with-partner.anvui-stop-point": "Transit Stop Point",
  "menu.transit-with-partner.transit-config": "Transit Stop Point Fee Configuration",
  "menu.transit-with-partner.report": "Transit Report",
  "menu.transit-with-partner.station-report": "Station Transit Report",
  "menu.transit-with-partner.surcharge-rules": "Surcharge Rules",
  "menu.landing": "An Vui Web Administration",
  "menu.landing.news": "News",
  "menu.landing.recruit": "Recruitment"
}
